// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__1uTtG","actions":"GroupTable_actions__2GprB","deleteModalFooter":"GroupTable_deleteModalFooter__16S_4"};